import { useMemo, useState, useEffect, useCallback } from 'react'
import moment from 'moment'

//* Components
import { Text, CustomLink, LikeDislike, Image, Avatar, Icon, CommentsCount } from 'components/common'
import Share from './Share'
import Actions from './Actions'
import Tags from './Tags'
import Favorite from '../Favorite'

//* Style
import DebateWindowStyle from './style'


const DebateWindow = (props) => {
    const {
        id,
        slug,
        title,
        content,
        topics,
        feedbackProCount,
        feedbackConCount,
        commentsCount,
        endDate,
        isPublic,
        user: debateUser,
        viewers,
        status,
    } = props.debate

    const [sharePopup, setSharePopup] = useState(false)
    const [reportPopup, setReportPopup] = useState(false)
    const [date, setDate] = useState()
    const [isFinished, setFinished] = useState(false)

    useEffect(() => {
        if (sharePopup || reportPopup) {
            document.addEventListener('click', clickHandler)
        }

        return () => {
            document.removeEventListener('click', clickHandler)
        }
    }, [sharePopup, reportPopup])

    useEffect(() => {
        if (status == 'finished') {
            setFinished(true)
            setDate('Finished')
        }
        else if (status == 'draft') {
            setFinished(true)
            setDate('Draft')
        } else {
            const diff = moment(endDate).diff(moment(), 'days') + 1
            setDate(`${diff} days left`)
        }
    }, [status, endDate])


    const clickHandler = useCallback((e) => {
        if (!(!!e.path.find((el) => el.classList?.contains('icon-pop')))) {
            let isExist = e?.path.find(el => el.classList?.contains('pop'));

            if (!isExist) {
                setReportPopup(false)
                setSharePopup(false)
            }
        }
    }, []);

    const storeParticipants = useMemo(() => {
        return viewers ? (
            <div className='liked flexBox alignMiddle'>
                <div className='avatars'>
                    {viewers.slice(0, 3).map((viewer) => (
                        <Avatar key={viewer.id} src={viewer.avatar} />
                    ))}
                </div>
                <Text tag={'p'} className='PopReg darkGrey' text={viewers.length} />
            </div>
        ) : null
    }, [viewers])

    return (
        <DebateWindowStyle className='flexBoxColumn single-debate-window' >
            <div className='header flexBox spaceBetween'>
                <div className='date flexBox alignMiddle'>
                    {!isFinished && <Icon className='op-watch grey' />}
                    <Text tag={'p'} className='h8 PopReg' text={date} />
                </div>
                <div className='share flexBox alignMiddle'>
                    {!isPublic && (
                        <Image className='lock' src='/images/lock.svg' />
                    )}
                    {status != 'draft' && (
                        <>
                            <Favorite debateId={id} />
                            <Share
                                slug={slug}
                                sharePopup={sharePopup}
                                setReportPopup={setReportPopup}
                                setSharePopup={setSharePopup}
                            />
                        </>
                    )}
                    <Actions
                        id={id}
                        slug={slug}
                        title={title}
                        status={status}
                        debateCreator={debateUser}
                        reportPopup={reportPopup}
                        setReportPopup={setReportPopup}
                        setSharePopup={setSharePopup}
                    />
                </div>
            </div>
            <CustomLink url={status === 'draft' ? `profile/debate/${id}` : `/debate/${slug}`} className='main flexBoxColumn'>
                <Text tag={'h4'} className='h4 PopSemi title line-clamp' text={title} />
                {content && <Text tag={'h5'} className='description h5 PopReg darkGrey line-clamp' text={content} />}
                <Tags tags={topics} />
            </CustomLink>
            <div className='footer flexBox spaceBetween'>
                <LikeDislike liked={feedbackProCount} disliked={feedbackConCount} />
                <CommentsCount defaultMouse commentsCount={commentsCount} />
                {storeParticipants}
            </div>
        </DebateWindowStyle>
    )
}

export default DebateWindow
